const Footer = ({ backgroundColor }) => {
  return (
    <div style={{backgroundColor: backgroundColor}}>
        <a href="legal_notice">Impressum</a>
    </div>
  );
};

export default Footer;
